module.exports = __webpack_public_path__ + "img/banner7.1fe2f86a.png";